__turbopack_context__.v({
  "billing-text": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__billing-text",
  "container": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__container",
  "container--with-margin": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__container--with-margin",
  "cta-container": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__cta-container",
  "icon-container": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__icon-container",
  "incentives-container": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__incentives-container",
  "learn-more-link": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__learn-more-link",
  "notice-container": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__notice-container",
  "notice-content": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__notice-content",
  "notice-description": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__notice-description",
  "notice-title": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__notice-title",
  "price": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__price",
  "price-container": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__price-container",
  "secondary-actions": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__secondary-actions",
  "title": "grow-with-google-enrollment-box-module-scss-module__pNcFGq__title",
});
